// Productos.js
import React, { useEffect, useRef } from 'react';

import { useNavigate } from 'react-router-dom';
import AOS from 'aos';
import styles from './Productos.module.css';
import star1 from './images/estrellaNegra.webp';
import star2 from './images//estrellaBlanca.webp';
import flecha from './images/flecha-hacia-abajo.webp';
import logo from './images/LOGO-BLANCO--SIN-LETRAS-HD.webp';

const Productos = () => {
  const navigate = useNavigate();
  /*
  useEffect(() => {
    AOS.init({
      duration: 200,  // Puedes ajustar la duración de las animaciones
      easing: 'ease-in-out',  // Ajusta el tipo de easing para una animación más fluida
      once: true,  // Si lo activas, la animación solo ocurre una vez
      offset: 100,  // Ajusta la distancia del scroll antes de que ocurra la animación
    });
  }, []);
  */
  const sectionsRef = useRef([]);

  useEffect(() => {
    const handleScroll = () => {
      const triggerBottom = window.innerHeight / 5 * 4;
      sectionsRef.current.forEach((box) => {
        const boxTop = box.getBoundingClientRect().top;
        if (boxTop < triggerBottom) {
          box.classList.add(styles.show);
        } else {
          box.classList.remove(styles.show);
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Ejecutar al montar el componente para verificar la posición inicial
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleArrowClick = () => {
    // Navega a la home page y luego añade el hash para la sección FAQ
    navigate('/#productSection', { replace: true });
  };

  // No permitir el scroll horizontal, bloquear
  useEffect(() => {
    document.body.style.overflowX = 'hidden';
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        {/*<img src={logo} alt="Logo de la empresa" className={styles.logo}></img>*/}
        <h1 className={styles.mainTitle}><span className={styles.highlightWhite}>Da el siguiente paso hacia la </span> <span className={styles.highlightBlue}>innovación</span></h1>
        <p className={styles.mainDescription}>Creamos <span className={styles.highlightBold}>Inteligencia Artificial</span> para tu empresa a través de software hecho a medida.</p>
        <img src={flecha} alt="Flecha hacia abajo" className={styles.flecha} onClick={handleArrowClick}></img>
      </div>
      <div id='productSection' className={styles.productSection} ref={(el) => (sectionsRef.current[0] = el)}>
        <div className={styles.line1}></div>
        <div className={styles.mainContent}>
            <img src={star1} alt="Estrella" className={styles.star1}></img>
            <h2 className={styles.productTitle} >Bot IA</h2>
            <p className={styles.productDescription} >
            Imagina un mundo donde las tareas repetitivas y los procesos engorrosos se manejan automáticamente.
            </p>
            {/* Enlazar el boton a la pagina de clones-info */}
            <button onClick={() => navigate('/clones-info')} className={styles.moreInfoButton} >Más información</button>
        </div>
        <div className={styles.imageContainer}>
          <div className={styles.productImage}></div>
          <div className={styles.backgroundImage1}></div>
        </div>
      </div>

      <div className={styles.productSection2} ref={(el) => (sectionsRef.current[1] = el)}>
        <div className={styles.line2}></div>
        <div className={styles.mainContent2}>
            <img src={star2} alt="Estrella" className={styles.star2} ></img>
            <h2 className={styles.productTitle2} >Calificador IA</h2>
            <p className={styles.productDescription2} >
            Con Calificador IA experimentarás múltiples beneficios, como la reducción de errores, la estandarización de criterios de calificación y una retroalimentación instantánea para los estudiantes.
            </p>
            <button onClick={() => navigate('/calificador-info')} className={styles.moreInfoButton2} >Más información</button>
        </div>
        <div className={styles.imageContainer2}>
          <div className={styles.productImage2}></div>
          <div className={styles.backgroundImage2}></div>
        </div>
      </div>

      <div className={styles.productSection3} ref={(el) => (sectionsRef.current[2] = el)}>
      <div className={styles.line1}></div>
        <div className={styles.mainContent}>
            <img src={star1} alt="Estrella" className={styles.star3} ></img>
            <h2 className={styles.productTitle3} >SmartBook IA</h2>
            <p className={styles.productDescription} >
              Transforma tu experiencia de lectura y estudio con el poder de la inteligencia artificial más avanzada para entender cada página como nunca antes.
            </p>
            <button onClick={() => navigate('/smartbook-ai-info')} className={styles.moreInfoButton} >Más información</button>
        </div>
        <div className={styles.imageContainer3}>
          <div className={styles.productImage3}></div>
          <div className={styles.backgroundImage3}></div>
        </div>
      </div>
    </div>
  );
};

export default Productos;